export function localDateKey(d){
  d = d || new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}
export function addDays(key, n){
  const d = new Date(key + 'T00:00:00');
  d.setDate(d.getDate() + n);
  return localDateKey(d);
}

export function diasEntre(de, ate){ return Math.round((new Date(ate+'T00:00:00') - new Date(de+'T00:00:00'))/86400000); }
export function listaDias(de, n){ return Array.from({length:n}, (_,i)=> addDays(de, i)); }
